import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CVA} from './cva';
import {UIFormEngineComponentMetadata} from './form';


@Component({
	selector: 'ui-input-default',
	template: `
		<div class="ui-input-presentation" *ngIf="presentationMode">
			{{cva.value}}
		</div>

		<ng-container *ngIf="!presentationMode">

			<input
				class="form-control"
				[(ngModel)]="cva.value"
				(ngModelChange)="writeValueFromInput($event)"
				[name]="name"
				[placeholder]="'('+(metadata?.options?.placeholder?metadata?.options?.placeholder:metadata?.label)+')'"
			/>

		</ng-container>
	`,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => UIInputDefaultComponent),
			multi: true
		}
	]
})
export class UIInputDefaultComponent extends CVA {
	@Input() metadata: UIFormEngineComponentMetadata;
	@Input() name;
	@Input() presentationMode = false;

}
